// ── SalesContactsPage — all contacts across sales accounts ──
import { useState, useEffect } from "react";
import { localFilter, exportCSV } from "../../../shared/format";
import { Btn, Card, ErrorMsg, ExportBtn, Icon, PageLink, Pagination, STh, SearchBar, SectionHeader, Spinner, Td, Th } from "../../../shared/ui";
import { useSortable, usePagination } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const SalesContactsPage = () => {
  const { api, role, rowNav, setModal, setConfirm, delRec } = useApp();
  const [rows, setRows] = useState([]); const [loading, setLoading] = useState(true); const [err, setErr] = useState(null);
  const [q, setQ] = useState("");

  const load = () => { setLoading(true); api.get("getContacts").then(d => { setRows(Array.isArray(d) ? d : []); setLoading(false); }).catch(e => { setErr(e.message); setLoading(false); }); };
  useEffect(() => { load(); }, []);

  const filtered = localFilter(rows, q, ["firstname", "lastname", "title", "companyname", "email", "phone", "mobilephone"]);
  const { sorted, sortKey, sortDir, toggle } = useSortable(filtered, 'lastname', 'asc');
  const { paginated: displayed, page, setPage, totalPages, total, reset } = usePagination(sorted, 100);

  if (loading) return <Spinner />; if (err) return <ErrorMsg msg={err} onRetry={load} />;
  return <>
    <SectionHeader actions={[
      <SearchBar key="s" value={q} onChange={v => { setQ(v); reset(); }} placeholder="Name, account, email, phone..." />,
      <ExportBtn key="ex" onClick={() => exportCSV(sorted, ["firstname", "lastname", "title", "companyname", "email", "phone", "mobilephone"], "sales_contacts.csv")}>Export CSV</ExportBtn>
    ]} />
    <Card style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", whiteSpace: "nowrap" }}>
        <thead><tr>
          <STh label="Name"    sortKey="lastname"    currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
          <STh label="Title"   sortKey="title"       currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
          <STh label="Account" sortKey="companyname" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
          <STh label="Email"   sortKey="email"       currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
          <STh label="Phone"   sortKey="phone"       currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
          <STh label="Mobile"  sortKey="mobilephone" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
          <Th></Th>
        </tr></thead>
        <tbody>{displayed.map(c => (
          <tr key={c.Id || c.id} style={{ cursor: "pointer" }} onClick={() => setModal({ type: "contact-view", rec: c, onDone: load })}
            onMouseEnter={e => e.currentTarget.style.background = "var(--color-background-secondary)"} onMouseLeave={e => e.currentTarget.style.background = ""}>
            <Td style={{ fontWeight: 500 }}>{[c.firstname, c.lastname].filter(Boolean).join(" ") || "—"}</Td>
            <Td>{c.title || "—"}</Td>
            <Td onClick={e => e.stopPropagation()}><PageLink page="sales-account" params={{ accountid: c.accountid, companyname: c.companyname }}>{c.companyname || "—"}</PageLink></Td>
            <Td>{c.email || "—"}</Td>
            <Td>{c.phone || "—"}</Td>
            <Td>{c.mobilephone || "—"}</Td>
            <Td><div style={{ display: "flex", gap: 6, justifyContent:"flex-end" }} onClick={e => e.stopPropagation()}>
              <Btn onClick={() => setModal({ type: "contact-view", rec: c, onDone: load })}><Icon type="view" /></Btn>
              {role.canEdit && <Btn onClick={() => setModal({ type: "contact-edit", rec: c, onDone: load })}><Icon type="edit" /></Btn>}
              {role.canDelete && <Btn onClick={() => setConfirm({ msg: "Delete this contact?", onConfirm: () => delRec("Contacts", c.Id || c.id, "Deleted contact", load) })} variant="danger"><Icon type="delete" /></Btn>}
            </div></Td>
          </tr>
        ))}</tbody>
        <tfoot><tr style={{ background: "var(--color-background-secondary)" }}>
          <td colSpan={7} style={{ padding: "10px 12px", fontSize: 13, fontWeight: 700, borderTop: "1.5px solid var(--color-border-secondary)" }}>Total ({sorted.length})</td>
        </tr></tfoot>
      </table>
      <Pagination page={page} totalPages={totalPages} total={total} pageSize={100} onPage={setPage} />
    </Card>
  </>;
};
